<template>
    <div class="user-project">
        <div class="user-project__inner">
            <a :href="url" class="user-project__cover">
                <img :src="image" :alt="title">
            </a>
            <div class="user-project__header flex between v-center">
                <div class="user-project__category">{{ category }}</div>
                <a :href="url" class="user-project__title">
                    <span class="user-project__company">{{ company }}</span> <span>{{ title }}</span>
                </a>
                <div class="user-project__chips flex gap-10 v-center">
                    <a-chip>{{ lead_time }}</a-chip>
                </div>
            </div>
            <div class="user-project__footer flex v-center between">
                <div class="user-project__tags gap-10">
                    <a-chip v-for="(tag, i) in tags" :key="i">{{ tag.name }}</a-chip>
                </div>
                <div class="user-project__rating flex v-center">
                    <svg class="icon" width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.9635 5.06994C13.8719 4.78645 13.6204 4.58511 13.3229 4.5583L9.28216 4.19139L7.68432 0.451504C7.56651 0.177419 7.29819 0 7.00007 0C6.70195 0 6.43364 0.177419 6.31582 0.452145L4.71798 4.19139L0.67656 4.5583C0.379616 4.58575 0.128816 4.78645 0.0366355 5.06994C-0.0555452 5.35342 0.0295858 5.66436 0.254216 5.86036L3.30857 8.53905L2.40791 12.5065C2.34201 12.7982 2.45523 13.0997 2.69727 13.2747C2.82737 13.3687 2.97958 13.4165 3.13307 13.4165C3.26542 13.4165 3.39669 13.3808 3.51451 13.3103L7.00007 11.2271L10.4844 13.3103C10.7393 13.4637 11.0607 13.4497 11.3022 13.2747C11.5444 13.0992 11.6575 12.7975 11.5916 12.5065L10.6909 8.53905L13.7453 5.8609C13.9699 5.66436 14.0557 5.35396 13.9635 5.06994Z"></path>
                    </svg>
                    <span>1/4</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { AChip } from '../ui'

export default {
    name: 'UserReviewCard',
    components: {
        AChip,
    },
    props: {
        company: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
        category: {
            type: String,
            default: '',
        },
        lead_time: {
            type: String,
            default: '',
        },
        rating: {
            default: '',
        },
        tags: {
            type: Array,
            default: () => []
        }
    },
    setup: (props, ctx) => {
        return {

        }
    },
}
</script>

<style lang="scss" scoped>
    .user-project {
        margin-bottom: 29px;
        &__inner {
            background: #fff;
            border-radius: var(--br-1);
            padding: 24px 30px;
            transition: all .3s ease;
            &:hover {
                box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
            }
            @include tablet {
                padding: 24px;
            }
        }
        &__header {
            .a-chip {
                font-weight: 600;

                @include mobile {
                    height: 30px;
                    font-size: 14px;
                    ::v-deep(.a-chip__inner) {
                        height: 30px;
                    }
                }
            }
            @include mobile {
                flex-direction: column;
                flex-wrap: wrap;
                align-items: stretch;
            }
        }
        &__cover {
            display: none;
            @include mobile {
                display: block;
                margin-bottom: 50px;
            }
        }
        &__title {
            max-width: 370px;
            font-size: 16px;
            line-height: 24px;
            color: var(--c-gray-100);
        }
        &__company {
            font-weight: 600;
        }
        &__category {
            display: none;
            @include mobile {
                display: block;
                color: var(--c-secondary-200);
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 8px;
            }
        }
        &__chips {
            @include mobile {
                margin-top: 45px;
            }
        }
        &__footer {
            margin-top: 19px;
            border-top: 1px solid var(--c-gray-700);
            padding-top: 24px;

            @include mobile {
                border-top: none;
            }
        }
        &__tags {
            @include mobile {
                .a-chip {
                    display: none;
                }
            }
        }
        &__rating {
            color: var(--c-gray-400);
            font-size: 14px;
            .icon {
                fill: currentColor;
                margin-right: 5px;
            }
        }
    }
</style>

<style lang="scss">
    .user-project__footer {
        .a-chip__inner {
            color: var(--c-secondary-300);
            border-color: var(--c-secondary-300);
        }
    }
</style>